var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32992 9.83323C2.06642 10.0737 1.7197 10.2073 1.35912 10.194C0.99853 10.194 0.665682 10.0604 0.402176 9.80651C0.15254 9.56603 -1.51487e-05 9.23202 -1.51528e-05 8.88465C-1.5157e-05 8.53728 0.124804 8.20327 0.374439 7.94942L8.2241 0.387451C8.34892 0.267208 8.50148 0.173685 8.6679 0.106883C8.83433 0.0400812 9.01462 1.1246e-07 9.19491 1.1031e-07C9.3752 1.0816e-07 9.5555 0.0400812 9.73579 0.106883C9.90221 0.173685 10.0548 0.267207 10.1796 0.387451L18.0293 7.94942C18.1541 8.06966 18.265 8.21663 18.3344 8.37695C18.4037 8.55064 18.4453 8.72432 18.4453 8.89801C18.4453 9.07169 18.4176 9.25874 18.3482 9.41906C18.2789 9.57939 18.1679 9.72635 18.0431 9.85995C17.9183 9.9802 17.7519 10.0737 17.5855 10.1405C17.419 10.2207 17.2387 10.2474 17.0446 10.2474C16.8643 10.2474 16.684 10.2073 16.5176 10.1405C16.3511 10.0737 16.1986 9.96684 16.0599 9.83323L9.19491 3.21985L7.90513 4.47572L2.32992 9.83323Z",
    fill: "#BCBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.b95d6883977d9f23b08ea801bd8273ae.svg";
export { ForwardRef as ReactComponent };